import { SpecificationConfigurationItem, SpecificationsLibrary } from '@grandvisionhq/fun-products'

export const commonSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.lensColor,
  SpecificationsLibrary.frameColor,
  SpecificationsLibrary.frameMaterial,
  SpecificationsLibrary.frameShape,
  SpecificationsLibrary.frameType,
  SpecificationsLibrary.gender,
  SpecificationsLibrary.roadworthiness,
]

export const clSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.materialType,
  SpecificationsLibrary.lensType,
  SpecificationsLibrary.material,
  SpecificationsLibrary.waterContent,
  SpecificationsLibrary.packageQuantity,
]

export const accessoriesSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.accessoryColor,
  SpecificationsLibrary.material,
  SpecificationsLibrary.erpID,
]
